import React, { useEffect, useState } from 'react';
import { Button, Col, Icon, Row } from '../../../../../../components/Component';
import TextInput from '../../../../../components/inputs/TextInput';
import { messageToast } from '../../../../../../utils/Utils';
import * as app_consts from "../../../../../../constants/react_app_consts";
import { Alert, Spinner } from 'reactstrap';
import { employee_dashboard_actions_helper } from '../../../../../../actions/actions_helper';
import { useDispatch } from 'react-redux';
import { BOOK_GOODS_RECEIVED_INTO_INVENTORY_API, FINALIZE_GRN_PROCESSING_API } from '../../../../../../api/api_data';
import { FINALIZE_GRN_PROCESSING_ACCESS_DENIED_MSG, FINALIZE_GRN_PROCESSING_ERR_MSG, FINALIZE_GRN_PROCESSING_SUCCESS_MSG } from '../../../../../../constants/success_error_messages_consts';
import { useSelector } from 'react-redux';
import { fail_book_goods_to_inventory, loading_book_goods_to_inventory, reset_book_goods_to_inventory, success_book_goods_to_inventory } from '../../../../../../reducers/dashboard_reducers/warehouse/book_goods_to_inventory_Slice';
import { isGrnWeightSequenceValid, resolveGrnNetWeight } from '../../../../../../utils/weighbridgeUtils';

const initialState = { first_weight: "", second_weight: "", net_weight: "", total_mt_capcity: "", total_density_mt_capacity: "" };

const FinalizeGRN = ({ page_data, openModal, successFunction }) => {

  const [sent_data, setSentData] = useState(page_data);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [formData, setFormData] = useState(initialState);
  const dispatch = useDispatch();

  useEffect(() => {
    if (openModal && page_data)
    {
      const totalCapacitySum = page_data?.goods_received_products?.reduce((sum, item) => {
        // Convert total_capacity_in_mt to a number and add to the sum
        return sum + parseFloat(item?.total_capacity_in_mt);
      }, 0);

      const totalDensityCapacitySum = page_data?.goods_received_products?.reduce((sum, item) => {
        // Convert total_capacity_in_mt to a number and add to the sum
        return sum + parseFloat(item?.uom_details?.total_density_kilos);
      }, 0);

      const firstWeight = page_data?.weigh_bridge_ticket?.first_weight || "";
      const secondWeight = page_data?.weigh_bridge_ticket?.second_weight || "";

      setFormData({
        ...formData,
        first_weight: firstWeight,
        second_weight: secondWeight,
        net_weight: resolveGrnNetWeight(
          page_data?.weigh_bridge_ticket?.net_weight || "",
          firstWeight,
          secondWeight,
        ),
        total_mt_capcity: totalCapacitySum,
        total_density_mt_capacity: totalDensityCapacitySum,
      });
    }
    setSentData(page_data);

  }, [openModal, page_data]);

  // Handle Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleOnblur = (e) => {
    if (e.target.name === "second_weight")
    {
      if (e.target.value)
      {
        if (!isGrnWeightSequenceValid(formData.first_weight, e.target.value, formData.net_weight))
        {
          setFormData({ ...formData, [e.target.name]: "", ["net_weight"]: "" });
          messageToast("First Weight (Gross) Cannot be less than Second Weight (Tare)", app_consts.FAIL);
        }
        else
        {
          setFormData({
            ...formData,
            [e.target.name]: parseFloat(e.target.value).toFixed(2),
            ["net_weight"]: resolveGrnNetWeight(
              formData?.net_weight,
              formData?.first_weight,
              e.target.value,
            ),
          });
        }
      }
      else
      {
        setFormData({ ...formData, [e.target.name]: "", ["net_weight"]: "" });
      }
    }
    else
    {
      if (e.target.value)
      {
        setFormData({ ...formData, [e.target.name]: parseFloat(e.target.value).toFixed(2) });
      }
    }
  };

  const handleSubmit = () => {
    setError("");
    const api_data = { ...formData, goods_received_ref_number: sent_data?.goods_received?.goods_received_ref_number };
    // Dispatch
    dispatch(
      employee_dashboard_actions_helper(
        loading_book_goods_to_inventory,
        success_book_goods_to_inventory,
        fail_book_goods_to_inventory,
        FINALIZE_GRN_PROCESSING_ERR_MSG,
        FINALIZE_GRN_PROCESSING_SUCCESS_MSG,
        app_consts.POST,
        FINALIZE_GRN_PROCESSING_API,
        api_data,
        FINALIZE_GRN_PROCESSING_ACCESS_DENIED_MSG
      )
    );
  };
  // Listen to Booking State
  const book_goods_to_inventory = useSelector((state) => state.book_goods_to_inventory.book_goods_to_inventory);

  useEffect(() => {
    if (book_goods_to_inventory.status !== app_consts.IDLE)
    {
      if (book_goods_to_inventory.status === app_consts.LOADING)
      {
        setError("");
        setLoading(true);
      } else
      {
        setLoading(false);
        if (book_goods_to_inventory.status === app_consts.FAIL)
        {
          setError(book_goods_to_inventory.message);
          messageToast(book_goods_to_inventory.message, app_consts.FAIL);
        } else if (book_goods_to_inventory.status === app_consts.SUCCESS)
        {
          messageToast(FINALIZE_GRN_PROCESSING_SUCCESS_MSG, app_consts.SUCCESS);
          successFunction();
        }
        dispatch(reset_book_goods_to_inventory());
      }
    }
  }, [book_goods_to_inventory]);

  return (
    <>
      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <Row className="g-4">
          <div className="form-label-group">
            <label className="form-label text-soft fs-22px">Finalize GRN</label>
          </div>
          <TextInput
            parentClassName="mt-4"
            colSize={6}
            label="Gross Weight"
            type="number"
            id_val="first_weight"
            value={formData?.first_weight}
            handleChange={handleChange}
            name="first_weight"
            onBlur={handleOnblur}
          />
          <TextInput
            parentClassName="mt-4"
            colSize={6}
            label="Tare Weight"
            type="number"
            id_val="second_weight"
            value={formData.second_weight}
            handleChange={handleChange}
            name="second_weight"
            onBlur={handleOnblur}
            disabled={!formData.first_weight}
          />
          <TextInput
            parentClassName="mt-4"
            colSize={6}
            label="Net Weight"
            type="number"
            id_val="net_weight"
            disabled
            value={formData?.net_weight}
            handleChange={handleChange}
            name="net_weight"
            onBlur={handleOnblur}
          />
          <TextInput
            parentClassName="mt-4"
            colSize={6}
            label="Total Products Density Weight (MT)"
            type="number"
            id_val="total_mt_capacity"
            value={formData.total_mt_capcity || ""}
            name="total_mt_capacity"
            disabled
          />
          <TextInput
            parentClassName="mt-4"
            colSize={6}
            label="Total Products Base Weight (MT)"
            type="number"
            id_val="total_mt_capacity"
            value={formData.total_density_mt_capacity || ""}
            name="total_mt_capacity"
            disabled
          />
          {error && (
            <div className="mt-4">
              <Alert color="danger" className="alert-icon">
                {" "}
                <Icon name="alert-circle" />
                {error}{" "}
              </Alert>
            </div>
          )}
          <Col xl="12">
            <div className="form-group">
              <div className="form-control-wrap-flex-wrap justify-end items">
                <Button
                  onClick={handleSubmit}
                  disabled={
                    loading
                      ? loading
                      : !(formData?.first_weight && formData.second_weight)
                  }
                  color="primary"
                  size="md"
                >
                  {loading ? <Spinner size="sm" color="light" /> : "Finalize GRN"}
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </form>
    </>
  );
};

export default FinalizeGRN;
